import { useState } from "react";
import React from "react";
import { ComposedModal, Button, ModalBody, ModalHeader, Grid, Row, Column } from "carbon-components-react";

function VisionPlanDetails() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ComposedModal open={open} onClose={() => setOpen(false)}>
        <ModalHeader className="mt-4 mb-2 -ml-4">
          <p className="text-2xl">MetLife Vision Plan Details</p>
          <p>(Copay includes Lenses and Frames)</p>
        </ModalHeader>
        <ModalBody aria-label="Plan Details">
          <div className="-ml-10 px-4">
            <Grid className="mb-8">
              <Row className="bg-gray-400">
                <Column className="py-2"></Column>
                <Column className="py-2 font-bold">In-Network</Column>
                <Column className="py-2 font-bold">Out-of-Network</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Vision Exam - Every 12 Months</Column>
                <Column className="mt-2 mb-2">$10 Copay</Column>
                <Column className="mt-2 mb-2">Reimbursed up to $52</Column>
              </Row>
              <Row className="bg-gray-200">
                <Column className="mb-2 mt-2">Single Lenses</Column>
                <Column className="mb-2 mt-2">$25 Copay</Column>
                <Column className="mb-2 mt-2">Reimbursed up to $55</Column>
              </Row>
              <Row>
                <Column className="mb-2 mt-2">Lined Bifocals</Column>
                <Column className="mt-2 mb-2">$25 Copay</Column>
                <Column className="mb-2 mt-2">Reimbursed up to $75</Column>
              </Row>
              <Row className="bg-gray-200">
                <Column className="mb-2 mt-2">Lined Trifocals</Column>
                <Column className="mb-2 mt-2">$25 Copay</Column>
                <Column className="mb-2 mt-2">Reimbursed up to $95</Column>
              </Row>
              <Row>
                <Column className="mb-2 mt-2">Lenticular</Column>
                <Column className="mb-2 mt-2">$25 Copay</Column>
                <Column className="mb-2 mt-2">Reimbursed up to $125</Column>
              </Row>
              <Row className="bg-gray-200">
                <Column className="mb-2 mt-2">Frames - Every 24 Months</Column>
                <Column className="mb-2 mt-2">$130 Allowance for frames of your choice and 20% off the amount over your allowance.</Column>
                <Column className="mb-2 mt-2">Reimbursed up to $57</Column>
              </Row>
              <Row>
                <Column className="mb-2 mt-2">Elective Contact Lenses - Every 12 Months</Column>
                <Column className="mb-2 mt-2">$130 allowance for contact lens exam (fitting & evaluation) and materials. If you choose contact lenses you will be eligible for frames 12 months from the date the contact lenses were obtained.</Column>
                <Column className="mb-2 mt-2">Reimbursed up to $105</Column>
              </Row>
              <Row className="bg-gray-200">
                <Column className="mb-2 mt-2">Additional Glasses and Sunglasses Discount</Column>
                <Column className="mb-2 mt-2">30% off additional glasses and sunglasses, including lens options, from the same VSP doctor on the same day as your exam. Or get 20% off from any VSP doctor within 12 months of your last exam.</Column>
                <Column className="mb-2 mt-2">N/A</Column>
              </Row>
              <Row>
                <Column className="mb-2 mt-2">Laser Vision Correction Discount - Once per eye per Lifetime</Column>
                <Column className="mb-2 mt-2">Average 15% off the regular price or 5% off the promotional price.</Column>
                <Column className="mb-2 mt-2">N/A</Column>
              </Row>
            </Grid>
            </div>
            <div className="mb-8 -ml-2 sm:ml-0">
              <div className="py-1 font-bold text-red-600">Website and Customer Service Information</div>
              <p>
              www.metlife.com
                <br />
                Vision Customer Service: 800-877-7195
              </p>
            </div>
            <div className="mb-8 -ml-2 sm:ml-0">
              <div className="py-1 font-bold text-red-600">Important Information</div>
              <p>
                • You do not need an ID Card for Vision Services. Simply visit a participating VSP provider and give the last 4-digits of the Employee SSN.
                <br />• Dependent children may be covered up to age 26. Your domestic partner and their children may be eligible for this plan. Please see Employee Relations for more details.
              </p>
            </div>
         
        </ModalBody>
      </ComposedModal>
      <Button kind="ghost" onClick={() => setOpen(true)}>
        View Plan Details
      </Button>
    </>
  );
}

export default VisionPlanDetails;
